"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var effector_1 = require("effector");
var index_1 = require("./index");
var logger_1 = __importDefault(require("../logger"));
var QBAdapter = __importStar(require("../QBAdapter"));
var sortingDialogs_1 = __importDefault(require("../utils/sortingDialogs"));
var array2map_1 = require("../utils/array2map");
var log = logger_1.default.module('Messages.onMessage');
var addInfoAboutDialogStatus = function (dialogs, income) {
    return __assign(__assign({}, income), { dialogExist: Object.keys(dialogs).includes(income.message.dialog_id) });
};
exports.default = (function (Messages$, MessagesOrder$, AllDialogs$, onMessage, onReadStatus, onDeliveredStatus, getDialogs, unreadMessage, getSession) {
    var incomeToMessageDTO = function (senderId, income) {
        return index_1.fillNewMessage({
            _id: income.id,
            created_at: income.extension.date_sent,
            updated_at: income.extension.date_sent,
            chat_dialog_id: income.dialog_id,
            message: income.body,
            date_sent: Number(income.extension.date_sent) || index_1.getUNIXTime(),
            sender_id: senderId,
            customAttributes: {
                location: income.extension.location,
                imageSize: income.extension.imageSize,
            },
            recipient_id: income.recipient_id || '0',
            read_ids: [senderId],
            delivered_ids: [senderId],
            attachments: (income.extension.attachments || []).map(index_1.withAttachmentLink),
        });
    };
    // streams
    // We receive own msg in group dialogs
    var filteredOnMessage = onMessage.filterMap(function (onMessageData) {
        var state = Messages$.getState();
        if (state[onMessageData.message.id]) {
            return undefined;
        }
        return onMessageData;
    });
    // Send delivery status
    onMessage.watch(function (params) {
        var session = getSession();
        if (params.userId !== session.user_id && params.message.markable !== 1) {
            QBAdapter.sendDeliveredStatus({
                userId: params.userId,
                dialogId: params.message.dialog_id,
                messageId: params.message.id,
            });
        }
    });
    var enhancedOnMessage = effector_1.sample(AllDialogs$, filteredOnMessage, addInfoAboutDialogStatus);
    var messagesByDialogStatus = effector_1.split(enhancedOnMessage, {
        exist: function (_a) {
            var dialogExist = _a.dialogExist;
            return dialogExist;
        },
        notExist: function (_a) {
            var dialogExist = _a.dialogExist;
            return !dialogExist;
        },
    });
    messagesByDialogStatus.notExist.watch(function (msg) {
        return getDialogs().then(function () { return afterReFetchDialogs(msg); });
    });
    var returnedStream = effector_1.merge([
        messagesByDialogStatus.exist,
        afterReFetchDialogs,
    ]).map(function (_a) {
        var userId = _a.userId, message = _a.message;
        return ({
            userId: userId,
            message: incomeToMessageDTO(userId, message),
        });
    });
    effector_1.forward({
        // FIXME: move to dialogs
        from: filteredOnMessage.map(function (msg) { return [msg.message.dialog_id]; }),
        to: unreadMessage,
    });
    AllDialogs$.on(filteredOnMessage, function (state, _a) {
        var _b;
        var _c;
        var message = _a.message;
        var dialog = state[message.dialog_id];
        if (!dialog) {
            return state;
        }
        var dateSent = message.extension.date_sent
            ? +new Date(Number(message.extension.date_sent))
            : +new Date();
        var updatedState = __assign(__assign({}, state), (_b = {}, _b[dialog._id] = __assign(__assign({}, dialog), { last_message_full: {
                _id: message.id,
                message: message.body,
                date_sent: dateSent,
                updated_at: dateSent,
                created_at: dateSent,
                chat_dialog_id: dialog._id,
                attachments: (_c = message.extension.attachments) === null || _c === void 0 ? void 0 : _c.map(index_1.withAttachmentLink),
                delivered_ids: [],
                customAttributes: {},
                read_ids: [],
                sender_id: message.recipient_id,
            } }), _b));
        var sortedDialogs = sortingDialogs_1.default(Object.values(updatedState));
        return __assign({}, array2map_1.array2Map(sortedDialogs, '_id'));
    });
    // stores
    Messages$.on(filteredOnMessage, function (state, _a) {
        var _b;
        var message = _a.message, userId = _a.userId;
        var formattedMessage = incomeToMessageDTO(userId, message);
        return __assign(__assign({}, state), (_b = {}, _b[formattedMessage._id] = formattedMessage, _b));
    });
    Messages$.on(onReadStatus, function (state, _a) {
        var _b;
        var userId = _a.userId, messageId = _a.messageId;
        var message = state[messageId];
        if (!message) {
            log.warn('Change read status: message doesnt exist at store', {
                messageId: messageId,
            });
            return state;
        }
        var updMessage = __assign(__assign({}, message), { read_ids: __spreadArrays(message.read_ids, [userId]) });
        return __assign(__assign({}, state), (_b = {}, _b[messageId] = updMessage, _b));
    });
    Messages$.on(onDeliveredStatus, function (state, _a) {
        var _b;
        var userId = _a.userId, messageId = _a.messageId;
        var message = state[messageId];
        if (!message) {
            log.warn('Change delivered status: message doesnt exist at store', {
                messageId: messageId,
            });
            return state;
        }
        var updMessage = __assign(__assign({}, message), { delivered_ids: __spreadArrays(message.delivered_ids, [userId]) });
        return __assign(__assign({}, state), (_b = {}, _b[messageId] = updMessage, _b));
    });
    MessagesOrder$.on(filteredOnMessage, function (state, newMessage) {
        var _a;
        var _b = newMessage.message, dialog_id = _b.dialog_id, message_id = _b.id;
        var oldMessageIds = state[dialog_id] || [];
        if (oldMessageIds.includes(message_id)) {
            return state;
        }
        return __assign(__assign({}, state), (_a = {}, _a[dialog_id] = __spreadArrays(oldMessageIds, [message_id]), _a));
    });
    return returnedStream.filterMap(function (params) {
        var user_id = getSession().user_id;
        return user_id !== params.userId ? params : undefined;
    });
});
var afterReFetchDialogs = effector_1.createEvent();
//# sourceMappingURL=onMessage.js.map